<template>
  <v-list>
    <draggable v-model="controls"
               :clone="clone"
               :group="{name: 'formbuilder', pull: 'clone', put:false}"
               :sort="false">
      <template v-for="control in controls">
        <Control :key="control.key"
                 :control='control'
                 class="formbuilder__controls"/>
      </template>
    </draggable>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import Control from '@/components/questionnaires/Control'

export default {
  name: 'ControlsHolder',
  components: {
    draggable,
    Control
  },
  computed: {
    ...mapGetters('Questionnaires', [
      'controls'
    ])
  },
  methods: {
    clone: ({ component, type }) => {
      return {
        id: null,
        key: Math.random()
          .toString(36)
          .substr(2, 16),
        component,
        type,
        value: '',
        extra: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .formbuilder__controls {
    cursor: grab;

    &:active {
      cursor: grabbing;
    }
  }
</style>
